// Module
var code = `<ex-mono-occurrence-ecran has-panneau-page="false"> <ex-mono-occurrence-ecran-bas> <ex-card-multi-advanced ex-bloc="imp" lbl-titre="LBL_BLC_IMP_BMG" multi-occurrence-options="vm.multiOccurrenceOptions" multi-occurrence-out="vm.multiOccurrence"> </ex-card-multi-advanced> </ex-mono-occurrence-ecran-bas> </ex-mono-occurrence-ecran> `;
// Exports
module.exports = code;